export default [
  { id: 'ServiceItemTypeDetail', label: 'Service Item Type Maintenance', parent: '' },
];
